import { Grid } from '@mui/material';
import { ErrorMessage, Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'shards-react';
import Api from '../../../core/api';
import Crud from '../../../components/Crud';
import { InputMask, InputRadio, InputText, Select, InputCheckbox } from '../../../components/FormHelper/Input';
import SelectAutoComplete from '../../../components/FormHelper/SelectAutoComplete';

export default function Eventos(props) {
    const { t } = useTranslation();
    const [parceiros, setParceiros] = useState([]);

    async function getParceiros() {
        const response = await Api('get', 'parceiros/options', '', {});
        setParceiros(response.data);
    }

    useEffect(() => {
        getParceiros();
    }, []);

    return (
        <>

               
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Field 
                        required
                        id="reuniao"
                        label={t('Tipo de Evento:')}
                        name="reuniao"
                        component={InputRadio}
                        list={[
                            { value: 'cafe_pastores', label: t('Café com Pastores') },
                            { value: 'reuniao_lideres', label: t('Reunião de Liderança') },
                            { value: 'eventos_cantores', label: t('Eventos com cantores') },
                            { value: 'conselho_pastores', label: t('Conselho de Pastores') },
                            { value: 'encontro_jovens', label: t('Encontro de Jovens') },
                            { value: 'evento_infantil', label: t('Evento Infantil') },
                            { value: 'encontro_homens', label: t('Encontro de Homens') },
                            { value: 'encontro_mulheres', label: t('Encontro de Mulheres') },
                            { value: 'encontro_negocios', label: t('Encontro de Negócios') },
                            { value: 'outros_eventos', label: t('Outros Eventos') },
                        ]}
                        error={<ErrorMessage name="reuniao" />}
                    />
                </Grid>
            </Grid>   
            <hr className='auto' />
            
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Field
                        required
                        id="parceiro_id"
                        label={t('Parceiros')}
                        name="parceiro_id"
                        component={SelectAutoComplete}
                        endPoint="parceiros/options"
                        placeholder="Selecione o Parceiro"
                        list={parceiros}
                        error={<ErrorMessage name="parceiro_id" />}
                    />
                </Grid>
            </Grid>   
            <hr className='auto' />
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <h6 className='line-title'>Oportunidades:</h6>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="distribuicao_material"
                        label={t('Distribuição de Material')}
                        name="distribuicao_material"
                        component={InputCheckbox}
                        error={<ErrorMessage name="distribuicao_material" />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="exibicao_trailer"
                        label={t('Exibição de trailler')}
                        name="exibicao_trailer"
                        component={InputCheckbox}
                        error={<ErrorMessage name="exibicao_trailer" />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="qr_code"
                        label={t('QR Code')}
                        name="qr_code"
                        component={InputCheckbox}
                        error={<ErrorMessage name="qr_code" />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="panfletagem"
                        label={t('Panfletagem')}
                        name="panfletagem"
                        component={InputCheckbox}
                        error={<ErrorMessage name="panfletagem" />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="exposicao_banner"
                        label={t('Exposição de Banner')}
                        name="exposicao_banner"
                        component={InputCheckbox}
                        error={<ErrorMessage name="exposicao_banner" />}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Field 
                        id="exibicao_vt"
                        label={t('Exibição de VT')}
                        name="exibicao_vt"
                        component={InputCheckbox}
                        error={<ErrorMessage name="exibicao_vt" />}
                    />
                </Grid>
               
               
                <Grid item xs={12} md={4}>
                    <Field 
                        id="testemunhal"
                        label={t('Testemunhal')}
                        name="testemunhal"
                        component={InputCheckbox}
                        error={<ErrorMessage name="testemunhal" />}
                    />
                </Grid>
                
            </Grid>
            <hr className='auto' />
            <Grid container spacing={2}>
                
                <Grid item xs={12} md={3}>
                    <Field 
                        required
                        id="data_acao"
                        label={t('Data da Ação')}
                        name="data_acao"
                        pattern="[0-9]*"
                        mask="##/##/####"
                        component={InputMask}
                        error={<ErrorMessage name="data_acao" />}
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <Field 
                        id="publico_medio_presente"
                        label={t('Público Médio presente?')}
                        name="publico_medio_presente"
                        pattern="[0-9]*"
                        component={InputText}
                        error={<ErrorMessage name="publico_medio_presente" />}
                    />
                </Grid>
            </Grid>

            <hr className='auto' />

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Field 
                        required
                        id="havia_transmissao"
                        label={t('Havia Transmissão Online?')}
                        name="havia_transmissao"
                        component={InputRadio}
                        list={[
                            { value: 'sim', label: t('Sim') },
                            { value: 'nao', label: t('Não') }
                        ]}
                        error={<ErrorMessage name="havia_transmissao" />}
                    />
                </Grid>
                {props.values.havia_transmissao === 'sim' &&
                    <Grid item xs={12} md={6}>
                        <Field 
                            required
                            id="publico_online_total"
                            label={t('Público online total estimado')}
                            name="publico_online_total"
                            pattern="[0-9]*"
                            component={InputText}
                            error={<ErrorMessage name="publico_online_total" />}
                        />
                    </Grid>
                }
            </Grid>
            
            {/* CRISTA */}
            <Grid container spacing={props.values.autoridade_crista_presentes === 'sim' ? 2 : 0}>
                <Grid item xs={12} md={6}>
                    <Field 
                        required
                        id="autoridade_crista_presentes"
                        label={t('Lideranças cristãs presentes?')}
                        name="autoridade_crista_presentes"
                        component={InputRadio}
                        list={[
                            { value: 'sim', label: t('Sim') },
                            { value: 'nao', label: t('Não') }
                        ]}
                        error={<ErrorMessage name="autoridade_crista_presentes" />}
                    />
                </Grid>

                {props.values.autoridade_crista_presentes === 'sim' &&
                    <Grid item xs={12} md={6}>
                        <Field 
                            required
                            id="n_estimado_autoridades"
                            label={t('Nº Estimado de Autoridades')}
                            name="n_estimado_autoridades"
                            pattern="[0-9]*"
                            component={InputText}
                            error={<ErrorMessage name="n_estimado_autoridades" />}
                        />
                    </Grid>
                }
            </Grid>

            {/* POLITICOS */}
            <Grid container spacing={props.values.autoridade_politicas_presentes === 'sim' ? 2 : 0}>
                <Grid item xs={12} md={6}>
                    <Field 
                        required
                        id="autoridade_politicas_presentes"
                        label={t('Autoridades Políticas Presentes?')}
                        name="autoridade_politicas_presentes"
                        component={InputRadio}
                        list={[
                            { value: 'sim', label: t('Sim') },
                            { value: 'nao', label: t('Não') }
                        ]}
                        error={<ErrorMessage name="autoridade_politicas_presentes" />}
                    />
                </Grid>

                {props.values.autoridade_politicas_presentes === 'sim' &&
                    <Grid item xs={12} md={6}>
                        <Field 
                            required
                            id="n_estimado_politicos"
                            label={t('Nº Estimado de Políticos')}
                            name="n_estimado_politicos"
                            pattern="[0-9]*"
                            component={InputText}
                            error={<ErrorMessage name="n_estimado_politicos" />}
                        />
                    </Grid>
                }
            </Grid>
            
            
        </>
    );
}